
import styled from 'styled-components';

const ChatsWrapper = styled.div`
  
.arrow {
  display: none !important;
  color: #fff;
}

.pagination-wrapper {
  margin-top: 15px;
  justify-content: center;
}

.ant-collapse-item {
  transition: all 0.3s ease-out;
  border: none;
  border-bottom: 1px solid transparent !important;
  box-shadow: 0 0 5px 1px transparent;
  border-radius: 20px;
  margin: 0 5px;
  &:hover {
    box-shadow: 0 0 5px 1px #ccc;
  }
  &:last-child {
    border-radius: 20px !important;
  }
}

`;

export default ChatsWrapper;



// WEBPACK FOOTER //
// ./src/components/Box/Chats/Chats.style.js